<template>
  <span class="pega-break">
    <div class="boss-scout-confirm-container">
      <div
        class="boss-scout-confirm-header"
        data-test="label-subject"
      >件名：{{ subject }}
      </div>
      <div class="boss-scout-confirm-body pega-pre-wrap">
        <div class="boss-scout-confirm-contents">
          <div class="boss-scout-confirm-contents-text clearfix">
            <div
              class="boss-scout-confirm-contents-sentence float-left"
              data-test="text-body"
              v-html="$sanitize(renderBody)"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="boss-layout-block">
      <div class="boss-table-wrap">
        <div class="boss-table-2">
          <div class="boss-table-2-layout boss-table-2-layout-half">
            <div class="boss-table-2-layout">
              <div class="boss-table-2-item boss-table-2-item-head">ステータス</div>
              <div class="boss-table-2-item boss-table-2-item-body">
                <label data-test="label-status">{{ status }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="boss-button-container">
      <button
        class="boss-button boss-button-return"
        type="button"
        data-test="button-back"
        @click="$emit('back')"
      ><span class="boss-button-return-text">戻る</span></button>
      <button
        class="boss-button-center boss-button-confirm"
        type="button"
        data-test="button-submit"
        @click="onSubmit"
      ><span class="boss-button-confirm-text">この内容で送信する</span></button>
    </div>
  </span>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import util from '@/lib/util'

export default {
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    subject () {
      return _.get(this.message, 'subject', '')
    },
    body () {
      return _.get(this.message, 'body', '')
    },
    renderBody () {
      return util.replaceAddressAndUrlLink(this.body)
    },
    status () {
      return (_.get(this.message, 'isStatusChange', false)) ? _.get(_.find(this.seminarStatuses, { id: _.get(this.message, 'statusId') }), 'name', '指定なし') : '更新しない'
    },
    ...mapGetters([
      'seminarStatuses'
    ])
  },
  methods: {
    onSubmit () {
      this.$emit('submitted')
    }
  }
}
</script>
